import {
  Button,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import SwitchToggle from "../../../components/SwitchToggle";
import AddEmissionsClass from "../../../Modals/addEmissionsClass";
import React from "react";

const ManageEmissionsClass = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [category, setCategory] = React.useState('default');
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  const [rows] = useState([
    { id: 1, name: "Euro 6", categories: ["Car", "Bike"], createdDate: "01-Sept-2025", status: true },
    { id: 2, name: "Euro 5", categories: ["Car", "Bike"], createdDate: "01-Sept-2025", status: true },
    { id: 3, name: "Euro 4", categories: ["Bike"], createdDate: "01-Sept-2025", status: true },
    { id: 4, name: "Euro 3", categories: ["Car"], createdDate: "01-Sept-2025", status: true },
  ]);

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      <div className="main_title">
        <h1>Manage Emissions Class
        </h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Emissions Class
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Emissions Classes..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={category}
                  onChange={handleCategoryChange}
                >
                  <MenuItem disabled value="default">Select Category</MenuItem>
                  <MenuItem value="Car">Car</MenuItem>
                  <MenuItem value="Bike">Bike</MenuItem>
                  <MenuItem value="Bicycle">Bicycle</MenuItem>
                  <MenuItem value="Caravan">Caravan</MenuItem>
                  <MenuItem value="Trucks">Trucks</MenuItem>
                  <MenuItem value="Heavy Equipment">Heavy Equipment</MenuItem>
                  <MenuItem value="Spare Parts">Spare Parts</MenuItem>
                  <MenuItem value="Car Accessories">Car Accessories</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Emissions Class
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Emissions Class Detail</TableCell>
                <TableCell>Categories</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <div className="user_block">
                      <p>
                        <b>{row.name}</b>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>{row.categories.join(", ")}</TableCell>
                  <TableCell>{row.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton
                        onClick={() => setOpenModal(true)}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddEmissionsClass
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageEmissionsClass;
